import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/catalogs',
    name: 'catalogs.index',
    component: () => import('./views/CatalogsIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      breadcrumb: 'Catálogos',
    },
  },
  {
    path: '/catalogs/empresas',
    name: 'catalogs.enterprises',
    component: () => import('./views/EnterprisesView.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      breadcrumb: 'Empresas',
    },
  },
]

export default routes
